'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './webaccess-list.routes';

export class WebaccessListComponent {
  constructor(Auth, WebAccessService, SettingsService, dialogs, $localStorage, DTOptionsBuilder, $scope, $uibModal, DTState) {
    'ngInject';

    this.WebAccessService = WebAccessService;
    this.data = [];
    this.filteredData = [];
    this.activeTabIndex = 0;
    this.$uibModal = $uibModal;

      SettingsService.getByName({name: 'config.app'}, appSettings => {
        this.webAccessGroupConfig = appSettings.data.webAccessGroupConfig || [];

        this.WebAccessService.query((data) => {
          this.data = data;
          this.filterData();
          this.dataInitComplete = true;
        }, err => {
          console.log("Could not retrieve website access.")
        });
      });


    this.dialogs = dialogs;

    this.dtOptions = DTOptionsBuilder.newOptions()
      .withOption('dom', 'lBfrtip')
      .withOption('order', [0, 'desc'])
      .withOption('stateSave',true)
      .withOption('stateSaveCallback', DTState.save())
      .withOption('stateLoadCallback', DTState.restore())
      .withOption('lengthMenu', [[10, 25, 50, 100, -1], [10, 25, 50, 100, "All"]])
      .withOption('buttons',[{
        extend: 'excel',
        title: "Website Access"
      },{
        extend: 'csv',
        title: "Website Access"
      },{
        title: "Website Access",
        message: 'As of ' + moment().format("MMMM Do YYYY"),
        extend: 'pdf',
        orientation: 'portrait',
        pageSize: 'LETTER'
      },{
        extend: 'print',
        title: "Website Access"
      }]);

    /*
    SettingsService.getByName({name: 'config.app'}, appSettings => {
      this.categories = appSettings.data.businessTypes;
    });*/
  }

  getComposedName(contact) {
    let composedName = "";

    if (contact.lastName && contact.firstName) {
      composedName = contact.lastName + ", " + contact.firstName;
      if (contact.middleName)
        composedName += " " + contact.middleName;
    }

    if (contact.company) {
      if (composedName == "")
        composedName += contact.company;
      else
        composedName += "<br/>" + contact.company;
    }

    return composedName || "-";
  }

  getCount(option) {

    switch (option) {
      case 'all':
        return this.rawFilteredData.length;
      case 'active':
        return this.rawFilteredData.filter(wa => wa.lastLogin && !wa.isBlocked).length;
      case 'blocked':
        return this.rawFilteredData.filter(wa => wa.isBlocked).length;
      case 'initial':
        return this.rawFilteredData.filter(wa => !(wa.lastLogin || wa.accountActivated) && wa.activationType == 'initial' && !wa.isBlocked).length;
      case 'invite-no-activation':
        return this.rawFilteredData.filter(wa => wa.lastInvite && !(wa.lastLogin || wa.accountActivated) && wa.activationType == 'invitation' && !wa.isBlocked).length;
      case 'no-invite-no-activation':
        return this.rawFilteredData.filter(wa => !wa.lastInvite && !(wa.lastLogin || wa.accountActivated) && wa.activationType == 'invitation' && !wa.isBlocked).length;
    }
  }
  
  setFilter(option) {

    switch (option) {
      case 'all':
        this.filter = null;
        this.filterData();
        break;
      case 'active':
        this.filter = option;
        this.filterData();
        this.filteredData = this.filteredData.filter(wa => wa.lastLogin && !wa.isBlocked);
        break;
      case  'blocked':
        this.filter = option;
        this.filterData();
        this.filteredData = this.filteredData.filter(wa => wa.isBlocked);
        break;
      case 'initial':
        this.filter = option;
        this.filterData();
        this.filteredData = this.filteredData.filter(wa => !(wa.lastLogin || wa.accountActivated) && wa.activationType == 'initial' && !wa.isBlocked);
        break;
      case 'invite-no-activation':
        this.filter = option;
        this.filterData();
        this.filteredData = this.filteredData.filter(wa => wa.lastInvite && !(wa.lastLogin || wa.accountActivated) && wa.activationType == 'invitation' && !wa.isBlocked);
        break;
      case 'no-invite-no-activation':
        this.filter = option;
        this.filterData();
        this.filteredData = this.filteredData.filter(wa => !wa.lastInvite && !(wa.lastLogin || wa.accountActivated) && wa.activationType == 'invitation' && !wa.isBlocked);
        break;
    }

  }

  openSendInvitationModal(resend) {
    var that = this;

    let title = (resend) ? "Resend Invitation" : "Send Invitation";

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'webaccessPicker',
      resolve: {
        config: function() {
          return {
            data: that.filteredData,
            title: title
          }
        }
      },
      size: 'md'
    });

    modalInstance.result.then(
      function (selectedWAIds) {
        that.WebAccessService.sendInvitations({ids: selectedWAIds}, _ => {

          if (that.filter == "no-invite-no-activation") {
            that.WebAccessService.query((data) => {
              that.data = data;
              that.filterData();
              that.setFilter(that.filter);
            }, err => {
              console.log("Could not retrieve website access.")
            });
          }

        }, err => console.log(err));
      },
      function () { /* cancel */ }
    );

  }

  filterData(code) {
    this.filteredData = this.data;
    this.rawFilteredData = angular.copy(this.filteredData);
  }

/*
  getCount(cat) {
    return this.data.reduce((acc, obj) => {
      return acc + (obj.type === cat);
    }, 0);
  }

  setFilter(cat) {
    jQuery("table.dataTable").DataTable().columns(1).search(cat).draw();
  }
*/
  delete(wa) {
    var that = this;

    var waText = "<br/><br/><b>" + wa.email + "</b>";

    var dlg = this.dialogs.confirm("Delete E-Voting Access?", "Do you really want to delete this e-voting access?" + waText);
    dlg.result.then(() => {
      // OK delete it
      that.WebAccessService.delete({id: wa._id},
        () => {
          that.data = that.data.filter(function( obj ) {
            return obj._id !== wa._id;
          });
          that.filteredData = that.filteredData.filter(function( obj ) {
            return obj._id !== wa._id;
          });
        },
        err => {
          alert("Could not delete e-voting access");
        });
    }, () => {
      // Cancel
    });
  }

}

export default angular.module('conduu.webaccessList', [uiRouter])
  .config(routes)
  .component('webaccessList', {
    template: require('./webaccess-list.html'),
    controller: WebaccessListComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/webaccess/list/webaccess-list.component.js